(function() {

  if (window.__seofyHomeInit) return;
  window.__seofyHomeInit = true;

  // Runs fn once the whole document has been parsed. Works correctly whether this
  // script loads early (e.g. from the Hero section, which renders first on the page,
  // before later sections like Services and Industries exist in the DOM yet) or late.
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function toggleFaq(btn){
    const item = btn.closest('.faq-item');
    const answer = item.querySelector('.faq-a');
    const wasOpen = item.classList.contains('open');
    document.querySelectorAll('.faq-item').forEach(i=>{
      i.classList.remove('open');
      i.querySelector('.faq-a').style.maxHeight = null;
      i.querySelector('.faq-q').setAttribute('aria-expanded', 'false');
    });
    if(!wasOpen){
      item.classList.add('open');
      answer.style.maxHeight = answer.scrollHeight + 'px';
      btn.setAttribute('aria-expanded', 'true');
    }
  }
  // init first faq open height
  window.addEventListener('load', ()=>{
    const open = document.querySelector('.faq-item.open .faq-a');
    if(open) open.style.maxHeight = open.scrollHeight + 'px';
  });

  // expose the function the HTML's inline onclick handlers need
  window.toggleFaq = toggleFaq;

  ready(function() {

  // industries tabs (progressive enhancement: all 16 panels are fully present and visible
  // in the raw HTML; this script only hides the non-active ones once it runs, so a no-JS
  // browser or a bot still sees every industry's complete content)
  const ind2Tabs = Array.from(document.querySelectorAll('.ind2-tab[data-industry]'));
  const ind2Panels = Array.from(document.querySelectorAll('.ind2-panel'));
  const ind2MoreBtn = document.getElementById('ind2-more-btn');
  const ind2MorePanel = document.getElementById('ind2-more-panel');

  function activateIndustryTab(tab, moveFocus) {
    const target = tab.getAttribute('data-industry');
    ind2Tabs.forEach(t => {
      const isActive = t === tab;
      t.classList.toggle('active', isActive);
      t.setAttribute('aria-selected', isActive ? 'true' : 'false');
      t.setAttribute('tabindex', isActive ? '0' : '-1');
    });
    ind2Panels.forEach(p => {
      const match = p.getAttribute('data-industry-panel') === target;
      p.classList.toggle('active', match);
      p.style.display = match ? '' : 'none';
    });
    if (moveFocus) tab.focus();
  }

  if (ind2Tabs.length) {
    ind2Panels.forEach((p, i) => { if (i !== 0) p.style.display = 'none'; });

    ind2Tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        activateIndustryTab(tab, false);
        if (ind2MorePanel && ind2MorePanel.contains(tab)) {
          ind2MorePanel.classList.remove('open');
          if (ind2MoreBtn) ind2MoreBtn.setAttribute('aria-expanded', 'false');
        }
      });
      tab.addEventListener('keydown', (e) => {
        let newIndex = null;
        if (e.key === 'ArrowRight') newIndex = (index + 1) % ind2Tabs.length;
        else if (e.key === 'ArrowLeft') newIndex = (index - 1 + ind2Tabs.length) % ind2Tabs.length;
        else if (e.key === 'Home') newIndex = 0;
        else if (e.key === 'End') newIndex = ind2Tabs.length - 1;
        if (newIndex !== null) {
          e.preventDefault();
          activateIndustryTab(ind2Tabs[newIndex], true);
        }
      });
    });
  }

  if (ind2MoreBtn && ind2MorePanel) {
    ind2MoreBtn.addEventListener('click', () => {
      const isOpen = ind2MorePanel.classList.toggle('open');
      ind2MoreBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
    document.addEventListener('click', (e) => {
      if (!ind2MoreBtn.contains(e.target) && !ind2MorePanel.contains(e.target)) {
        ind2MorePanel.classList.remove('open');
        ind2MoreBtn.setAttribute('aria-expanded', 'false');
      }
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && ind2MorePanel.classList.contains('open')) {
        ind2MorePanel.classList.remove('open');
        ind2MoreBtn.setAttribute('aria-expanded', 'false');
        ind2MoreBtn.focus();
      }
    });
  }

  // services tabs (progressive enhancement: all 8 panels AND all 8 benefit rows are visible
  // in the raw HTML; this script is what hides the non-active ones once it runs, never what
  // reveals them, so a no-JS browser or a bot sees every service's full content)
  const svcTabs = Array.from(document.querySelectorAll('.svc-tab'));
  const svcPanels = Array.from(document.querySelectorAll('.svc-panel'));
  const svcBenefitRows = Array.from(document.querySelectorAll('.svc-benefits'));

  function activateServiceTab(tab, moveFocus) {
    const target = tab.getAttribute('data-service');
    svcTabs.forEach(t => {
      const isActive = t === tab;
      t.classList.toggle('active', isActive);
      t.setAttribute('aria-selected', isActive ? 'true' : 'false');
      t.setAttribute('tabindex', isActive ? '0' : '-1');
    });
    svcPanels.forEach(p => {
      const match = p.getAttribute('data-service-panel') === target;
      p.classList.toggle('active', match);
      p.style.display = match ? '' : 'none';
    });
    svcBenefitRows.forEach(b => {
      const match = b.getAttribute('data-benefits-panel') === target;
      b.classList.toggle('active', match);
      b.style.display = match ? '' : 'none';
    });
    if (moveFocus) tab.focus();
  }

  if (svcTabs.length) {
    // JS is running, so it's now safe to hide all but the first panel and first benefit row.
    svcPanels.forEach((p, i) => { if (i !== 0) p.style.display = 'none'; });
    svcBenefitRows.forEach((b, i) => { if (i !== 0) b.style.display = 'none'; });

    svcTabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activateServiceTab(tab, false));
      tab.addEventListener('keydown', (e) => {
        let newIndex = null;
        if (e.key === 'ArrowDown') newIndex = (index + 1) % svcTabs.length;
        else if (e.key === 'ArrowUp') newIndex = (index - 1 + svcTabs.length) % svcTabs.length;
        else if (e.key === 'Home') newIndex = 0;
        else if (e.key === 'End') newIndex = svcTabs.length - 1;
        if (newIndex !== null) {
          e.preventDefault();
          activateServiceTab(svcTabs[newIndex], true);
        }
      });
    });
  }

  // services mobile accordion (progressive enhancement: all 8 items' full content is
  // present and visible in the raw HTML; this script only collapses the non-active ones
  // once it runs, so a no-JS browser or a bot on a small screen still sees every service)
  const accItems = Array.from(document.querySelectorAll('.svc-acc-item'));
  if (accItems.length) {
    accItems.forEach((item, i) => {
      const trigger = item.querySelector('.svc-acc-trigger');
      const panel = item.querySelector('.svc-acc-panel');
      if (i !== 0) {
        panel.style.display = 'none';
      }
      trigger.addEventListener('click', () => {
        const isOpen = item.classList.contains('active');
        accItems.forEach(other => {
          const otherTrigger = other.querySelector('.svc-acc-trigger');
          const otherPanel = other.querySelector('.svc-acc-panel');
          other.classList.remove('active');
          otherTrigger.setAttribute('aria-expanded', 'false');
          otherPanel.style.display = 'none';
        });
        if (!isOpen) {
          item.classList.add('active');
          trigger.setAttribute('aria-expanded', 'true');
          panel.style.display = '';
          // bring the top of the item (its header) into view, rather than letting the
          // browser leave the viewport wherever the newly-expanded content happens to land
          requestAnimationFrame(() => {
            trigger.scrollIntoView({ behavior: 'smooth', block: 'start' });
          });
        }
      });
    });

    // quiet visual nudge on chevrons the user hasn't opened yet, triggered the moment
    // each item scrolls into view, not on page load, so it's still visible while scrolling
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reducedMotion && 'IntersectionObserver' in window) {
      const accIo = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          const item = entry.target;
          if (!item.classList.contains('active')) {
            const chevron = item.querySelector('.svc-acc-chevron');
            chevron.classList.add('svc-acc-chevron-nudge');
          }
          accIo.unobserve(item);
        });
      }, { threshold: 0.6 });
      accItems.forEach(item => { if (!item.classList.contains('active')) accIo.observe(item); });
    }
  }

  // scroll reveal
  const io = new IntersectionObserver((entries)=>{
    entries.forEach(e=>{ if(e.isIntersecting) e.target.classList.add('in'); });
  }, {threshold:0.15});
  document.querySelectorAll('.reveal').forEach(el=>io.observe(el));

  // hero contact form: honeypot + minimum-fill-time spam guard.
  // Real visitors never see or fill the honeypot field, and never submit in under 2 seconds.
  // Blocked attempts are silently stopped, nothing is shown, so scripted bots get no feedback to adapt to.
  const heroForm = document.getElementById('HeroContactForm');
  if (heroForm) {
    const loadedAtField = document.getElementById('HeroFormLoadedAt');
    if (loadedAtField) loadedAtField.value = Date.now();

    heroForm.addEventListener('submit', function(e) {
      const honeypot = document.getElementById('HeroContactCompany');
      const loadedAt = parseInt((loadedAtField && loadedAtField.value) || '0', 10);
      const elapsed = Date.now() - loadedAt;

      if ((honeypot && honeypot.value.trim() !== '') || elapsed < 2000) {
        e.preventDefault();
      }
    });
  }

  }); // end ready()

})();